module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "ethtrader"
    }
  }, [_c('v-content', [_c('v-container', [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "fixed",
      "bottom": "32px",
      "width": "100%"
    },
    attrs: {
      "column": ""
    }
  }, _vm._l((_vm.transactions), function(ref, idx) {
    var label = ref.label;
    var result = ref.result;
    var error = ref.error;

    return _c('transaction-notify', {
      key: idx,
      attrs: {
        "label": label,
        "result": result,
        "error": error
      }
    })
  })), _vm._v(" "), _c('v-footer', {
    attrs: {
      "app": "",
      "fixed": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('span', {
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("© 2018")]), _vm._v(" "), _c('div', {
    attrs: {
      "xs2": ""
    }
  }, [_vm._v(_vm._s('Total REC: ' + _vm.supply))]), _vm._v(" "), _c('div', {
    attrs: {
      "xs2": ""
    }
  }, [_vm._v(_vm._s('network: ' + _vm.network))]), _vm._v(" "), _c('div', {
    attrs: {
      "xs2": ""
    }
  }, [_vm._v(_vm._s('block: ' + _vm.blockNum))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50fd82f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue
// module id = 264
// module chunks = 1